export default "__VITE_ASSET__D8SqWnX8__"